// South Africa provinces and Autozone branch placeholder data (30 branches).
// Editable later by the client if exact branch names differ.

export const LOCATIONS = [
  {
    province: "Gauteng",
    branches: [
      "Autozone Sandton",
      "Autozone Randburg",
      "Autozone Centurion",
      "Autozone Boksburg",
      "Autozone Pretoria CBD",
      "Autozone Midrand",
    ],
  },
  {
    province: "Western Cape",
    branches: [
      "Autozone Cape Town CBD",
      "Autozone Bellville",
      "Autozone Paarl",
      "Autozone George",
    ],
  },
  {
    province: "KwaZulu-Natal",
    branches: [
      "Autozone Durban North",
      "Autozone Pinetown",
      "Autozone Pietermaritzburg",
      "Autozone Richards Bay",
    ],
  },
  {
    province: "Eastern Cape",
    branches: [
      "Autozone Gqeberha",
      "Autozone East London",
      "Autozone Mthatha",
    ],
  },
  {
    province: "Free State",
    branches: ["Autozone Bloemfontein", "Autozone Welkom"],
  },
  {
    province: "Mpumalanga",
    branches: [
      "Autozone Mbombela",
      "Autozone Emalahleni",
      "Autozone Secunda",
    ],
  },
  {
    province: "Limpopo",
    branches: [
      "Autozone Polokwane",
      "Autozone Tzaneen",
      "Autozone Thohoyandou",
    ],
  },
  {
    province: "North West",
    branches: [
      "Autozone Rustenburg",
      "Autozone Potchefstroom",
      "Autozone Mahikeng",
    ],
  },
  {
    province: "Northern Cape",
    branches: ["Autozone Kimberley", "Autozone Upington"],
  },
];

export const getBranchesForProvince = (province) => {
  const found = LOCATIONS.find((l) => l.province === province);
  return found ? found.branches : [];
};
